import { Box } from '@mui/material';
import { LucideWifi, WifiOff } from 'lucide-react';
import { CSSProperties } from 'react';

interface NotifierStatusSectionProps {
  styles: Record<string, CSSProperties>;
  isConnected: boolean;
}

export const NotifierStatusSection = ({ styles, isConnected }: NotifierStatusSectionProps) => (
  <Box sx={{
    ...styles.engineItem,
    ...(isConnected ? styles.notifierConnected : styles.notifierDisconnected),
    my: 1
  }}>
    {isConnected ? (
      <LucideWifi size={20} color={styles.notifierConnected.color} />
    ) : (
      <WifiOff size={20} color={styles.notifierDisconnected.color} />
    )}
    <div style={styles.engineInfo}>
      <p style={styles.engineName}>
        Notifier Service
      </p>
      <p style={{
        ...styles.engineStatus,
        color: isConnected ? styles.notifierConnected.color : styles.notifierDisconnected.color
      }}>
        {isConnected ? 'Connected' : 'Not Connected'}
      </p>
    </div>
  </Box>
); 